import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("directors-cut", "Director's Cut", "img/projects/directors-icon.gif", 
    `
    <div class="paragraph">
     <strong>Director's Cut</strong> is a fun hidden role game with a dark backstory, the director(s) need to eliminate all the broke actors before they complete all of their respective acting tasks.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/IyMftUe83fE?si=FmBiJyD4e1ODe96I" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph">
        This game was made in 3 months for a university project, my main role was to do all the networking, I also worked on the main scene, polishing and optimizing.
        <br><br>
        Main features :
        <ul>
        <li>Online (2-6) using Photon Pun, Chat and Voice.</li>
        <li>Players communicate through text chat or proximity voice chat to find out who the directors are in order to vote them out.</li>
        <li>Acting tasks are randomly given at the game start and are synced with everyone.</li>
        <li>Great repeatability and quick games to give everyone the chance of being "the bad guy".</li>
        <li>Teamwork with three other programmers</li>
        </ul>
    </div>

    <div class="paragraph">
    <div class="notice">
        Windows build and source code available on <a href="https://github.com/niiK0/Directors-Cut" target="_blank">GitHub</a>.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/Bm1koLBJ_Wk?si=BcoN-EO2RY3C95T9" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/directors-1.png" alt="Director's Cut Game Photo" />
        <img class="pc-screenshot" src="img/projects/directors-2.png" alt="Director's Cut Game Photo" />
        <img class="pc-screenshot" src="img/projects/directors-3.png" alt="Director's Cut Game Photo" />
        <img class="pc-screenshot" src="img/projects/directors-4.png" alt="Director's Cut Game Photo" />
    </div>
    </div>
    `, "#383838", true, true),
    new ProjectData("insanity", "Insanity", "img/projects/insanity-4.png",
        `
        <div class="paragraph">
            <strong>Insanity</strong> is an adventure level-based game featuring <strong>FPS</strong> and <strong>RPG</strong> elements. The story follows a pacient who suffers from <strong>Schizophrenia</strong> and has the goal of escaping the psychiatric hospital. 
        </div>
    
        <div class="paragraph">
            This game was made in 2 months for a university project, my main role was to make the stats system and anything related to it, I also worked on the player, enemies, main scene, polishing and optimizing.
            <br><br>
            Main features :
            <ul>
            <li>The player needs to slay enemies in each procedurally generated room in order to go to the next one and find the exit.</li>
            <li>Each enemy will drop a random stat upgrade.</li>
            <li>Before the game starts, the player can choose one of three types of Schizophrenia available, which essentially just gives different starting stats.</li>
            <li>The player needs to swap between Sane and Insane modes where he sees stuff differently and helps him stabilize his sanity meter.</li>
            <li>At the end of the maze the player enters the Boss room.</li>
            <li>Teamwork with one other programmer</li>
            </ul>
        </div>

       <div class="paragraph">
        <div class="notice">
            Windows build available on <a href="https://niik0.itch.io/insanity" target="_blank">itch.io</a>.
            Source code is available on <a href="https://github.com/niiK0/Insanity?tab=readme-ov-file" target="_blank">GitHub</a>.
        </div>
        </div>

        <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/insanity-1.png" alt="insanity Game Photo" />
        <img class="pc-screenshot" src="img/projects/insanity-2.png" alt="insanity Game Photo" />
        <img class="pc-screenshot" src="img/projects/insanity-3.png" alt="insanity Game Photo" />
        <img class="pc-screenshot" src="img/projects/insanity-4.png" alt="insanity Game Photo" />
        </div>
    `, "#6B3FA0", true, false),
    new ProjectData("thehorde", "The Horde", "img/projects/thehorde-icon.gif", `
        <div class="paragraph">
            <strong>The Horde</strong> is an FPS survival game where the player has to survive as many waves of enemies as they can, saving the highscore on a website platform made only for the game.
        </div>
        <div class="paragraph center">
            <iframe class="youtube" src="https://www.youtube.com/embed/GghMMVgGIOc?si=Fgz4nWXjuIkHXH0k" frameborder="0" allowfullscreen></iframe>
        </div>
    
        <div class="paragraph">
            This was my first ever game, made in 2 months for my high school final project, alongside a website that serves as a leaderboard platform for the game.
            <br><br>
            Main features :
            <ul>
            <li>Survive waves of enemies.</li>
            <li>Each wave spawns more and stronger enemies.</li>
            <li>Website build using HTML, JS, CSS, BOOTSTRAP, PHP and SQL</li>
            </ul>
        </div>
    
        <div class="paragraph">
        <div class="notice">
            Windows build available on <a href="https://niik0.itch.io/the-horde" target="_blank">itch.io</a>.
            Source code is available on <a href="https://github.com/niiK0/The-Horde?tab=readme-ov-file" target="_blank">GitHub</a>.
        </div>
        </div>
    `, "#5C5C5C", false, false),
    new ProjectData("interanao", "InteraNão", "img/projects/interanao-icon.gif", `
    <div class="paragraph">
        <strong>InteraNão</strong> is a puzzle game where a worker has to leave his office and walk all the way to his boss' office in order to quit his job. He has to avoid his co-workers on the way since he has social anxiety.
    </div>
    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/interanao-icon.gif" alt="InteraNao gif" />
    </div>

    <div class="paragraph">
        This game was made in two days for my first ever game jam at the <strong>IPCA Game Jam 2023</strong> event, where we got 1st place and took the trophy home. The jam's theme was "Interaction".
        <br><br>
        Main features :
        <ul>
        <li>Singleplayer puzzle game</li>
        <li>Players need to collect the keys in order to use them (ex: if you don't have the A key you can't move right)</li>
        <li>Keys need to be placed in the world in order to complete puzzles, but leaving the player without that key to move.</li>
        <li>Avoid the co-workers by throwing a phone at them or close to distract them, allowing you to pass.</li>
        <li>Teamwork with the other programmer and two artists</li>
        </ul>
    </div>

    <div class="paragraph">
    <div class="notice">
        Windows build available on <a href="https://itch.io/jam/ipca-gamejam-2023/rate/2091208" target="_blank">itch.io</a>.
        Source code is available on <a href="https://github.com/niiK0/GameJamIPCA2023-Winners-" target="_blank">GitHub</a>.
    </div>
    </div>

    <div class="paragraph center">
    <img class="pc-screenshot" src="img/projects/interanao-1.png" alt="Interanao Game Photo" />
    <img class="pc-screenshot" src="img/projects/interanao-2.png" alt="Interanao Game Photo" />
    <img class="pc-screenshot" src="img/projects/interanao-3.png" alt="Interanao Game Photo" />
    <img class="pc-screenshot" src="img/projects/interanao-4.png" alt="Interanao Game Photo" />
    </div>
    `, "#004d00", false, true),
    new ProjectData("inffighter", "Infinite Fighter", "img/projects/inffighter-1.png", `
        <div class="paragraph">
            <strong>Infinite Fighter</strong> is an arcade game inspired by the classic space invaders, after five minutes of leveling stats and avoiding meteors, a final boss shows up.
        </div>
        <div class="paragraph center">
            <img class="pc-screenshot" style="height: 20em; width: 40em;" src="img/projects/inffighter-1.png" alt="Infinite Fighter Game Photo" />
        </div>
    
        <div class="paragraph">
            Main features :
            <ul>
            <li>Web game using HTML, CSS and JS.</li>
            <li>Utilizes a temperature API for color theme.</li>
            <li>Enemies drop experience, leveling gives a random stat</li>
            </ul>
        </div>
    
        <div class="paragraph">
        <div class="notice">
            Windows build and source code available on <a href="https://github.com/niiK0/IPCA-PWD?tab=readme-ov-file" target="_blank">GitHub</a>.
        </div>
        <div class="paragraph center">
            <img class="pc-screenshot" src="img/projects/inffighter-2.png" alt="Infinite Fighter Game Photo" />
            <img class="pc-screenshot" src="img/projects/inffighter-3.png" alt="Infinite Fighter Game Photo" />
        </div>
        </div>
    `, "#1B1B58", false, true),
];